import { render, staticRenderFns } from "./LessonView.vue?vue&type=template&id=340a1319&scoped=true&"
import script from "./LessonView.vue?vue&type=script&lang=js&"
export * from "./LessonView.vue?vue&type=script&lang=js&"
import style0 from "./LessonView.vue?vue&type=style&index=0&id=340a1319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340a1319",
  null
  
)

export default component.exports